// Post Art
export const POST_ART_REQUEST = "POST_ART_REQUEST"
export const POST_ART_SUCCESS = "POST_ART_SUCCESS"
export const POST_ART_FAIL = "POST_ART_FAIL"


// Get Art By User ID

export const GET_ART_BY_USER_ID_REQUEST="GET_ART_BY_USER_ID_REQUEST"
export const GET_ART_BY_USER_ID_SUCCESS = "GET_ART_BY_USER_ID_SUCCESS"
export const GET_ART_BY_USER_ID_FAIL= "GET_ART_BY_USER_ID_FAIL"